<script setup lang="ts">
import IconBase from '../IconBase.vue';

interface Props {
  size?: number;
}

const props = withDefaults(defineProps<Props>(), {
  size: 4,
});
</script>

<template>
  <IconBase :size="size">
    <svg viewBox="0 0 1 2" fill="none" xmlns="http://www.w3.org/2000/svg">
      <circle cx="0.5" cy="1" r="0.5" fill="currentColor" />
    </svg>
  </IconBase>
</template>
